import axios from '../axios'
import type { MarketTickerModel, MarketRepository } from '@trading/core'

type ApiEnvelope<T> = {
  data?: T
}

function unwrapApiData<T>(payload: unknown): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as ApiEnvelope<T>).data as T
  }

  return payload as T
}

export class MarketApiAxios implements MarketRepository {
  async getSymbols(): Promise<string[]> {
    const response = await axios.get('market/symbols')
    const payload = unwrapApiData<string[] | { symbols: string[] }>(response.data)

    if (Array.isArray(payload)) return payload

    if (payload && typeof payload === 'object' && Array.isArray(payload.symbols)) {
      return payload.symbols
    }

    return []
  }

  async getTickers(): Promise<MarketTickerModel[]> {
    const response = await axios.get('market/tickers')
    const payload = unwrapApiData<MarketTickerModel[]>(response.data)

    return Array.isArray(payload) ? payload : []
  }
}
